import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Contact.css';

const Contact = () => {
  const [notification, setNotification] = useState(null);

  const sendEmail = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const templateParams = Object.fromEntries(formData);
    const email = templateParams.email;
    if (!email) {
      toast.error('Please enter your email', { autoClose: 3000 });
      return;
    }

    emailjs
      .send('service_jjsxbof', 'template_1ro6u9y', templateParams, 'ABPANOGA4S7nEoAG9')
      .then((response) => {
        // Send the auto-reply email
        emailjs.send('service_jjsxbof', 'auto_reply_template', {
          to_email: email,
          userEmail: email
        }, 'ABPANOGA4S7nEoAG9');

        toast.success('Email sent successfully!', { autoClose: 2000 });
      })
      .catch((error) => {
        toast.error('Failed to send email', { autoClose: 2000 });
        console.error('Failed to send email:', error);
      });

    event.target.reset();
  };

  return (
    <div className="contact-page">
      <ToastContainer position="top-right" />
      <div className="contact-section">
        <h1>Contact Us Page</h1>
        <p>Do you have any questions?</p>
        <p>Just send us a message and we will get back to you</p>
      </div>
      <div className="container">
        <div></div>
        <div className="contact-row">
          <div className="contact-column">
            <img
              src="https://preachnthegospel.files.wordpress.com/2019/01/questions.jpg"
              height="400px"
              alt="map"
            />
          </div>
          <div className="contact-column">
            {notification && <div className="notification">{notification}</div>}
            <form className="contact-page-form" onSubmit={sendEmail}>
              <label htmlFor="fname">First Name</label>
              <input type="text" id="fname" name="firstname" placeholder="Your name.." />
              <label htmlFor="lname">Last Name</label>
              <input type="text" id="lname" name="lastname" placeholder="Your last name.." />

              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" placeholder="Your email.." />

              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" placeholder="Subject" />
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" placeholder="Write something.."></textarea>
              <input type="submit" value="Submit" className="contact-page-form" />
            </form>
          </div>
        </div>
      </div>
      <div className="embeded-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1660.63572751083!2d73.07903012566814!3d33.650127545155634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df952e017d0acd%3A0xf20be4a76782ceaf!2sPir%20Mehr%20Ali%20Shah%20Arid%20Agriculture%20University%20-%20PMAS%20AAUR!5e0!3m2!1sen!2sus!4v1666956975991!5m2!1sen!2sus"
          width="100%"
          height="600"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;